import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import financialTransactionsApi from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useRecalculatePaymentStatuses = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: () => financialTransactionsApi.recalculatePaymentStatuses(),
    onSuccess: () => {
      toast.success('Statusy płatności zostały przeliczone');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się przeliczyć statusów płatności', {
        description: error.message,
      });
    },
  });
};

export default useRecalculatePaymentStatuses;
